/**
 * Sinf nomlarini birlashtirish.
 *
 * `clsx`/`tailwind-merge` qo'shilmadi: MVP_PLAN §6 «komponent kutubxonasi
 * qo'shilmaydi» qoidasiga mos va bu 6 qator kod uchun bog'liqlik ortiqcha.
 */
export type ClassValue = string | false | null | undefined;

export function cn(...values: readonly ClassValue[]): string {
  return values.filter(Boolean).join(' ');
}
